/**
 * AppWeb Theme Preset
 *
 * Theme for sipgate AppWeb internal application
 * Features: Larger conversation window, standard styling
 */

import { ThemePreset } from '../../components/Widget/ThemeContext';

export const appwebTheme: ThemePreset = {
    themeName: 'appweb',
    showTitleBar: true,

    colors: {
        primary: '#135afe',
        background: '#ffffff',
        launcher: '#135afe',
        userMessage: '#135afe',
        userMessageText: '#ffffff',
        assistantMessage: '#f4f7f9',
        assistantMessageText: '#000000',
        headerBackground: '#135afe',
        headerText: '#ffffff',
    },

    typography: {
        fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    },

    dimensions: {
        height: '650px',
        width: '370px',
        heightLarge: '752px',
        widthLarge: '848px',
    },

    borderRadius: {
        bubble: '8px',
        button: '8px',
        window: '8px', // Rounded corners for conversation window
        launcher: '50%',
    },

    boxShadow: {
        launcher: '0 3px 6px rgba(0, 0, 0, 0.15)',
        window: '0 1px 1.5px -1px rgba(0, 0, 0, 0.048), 0 2.5px 3.7px -1px rgba(0, 0, 0, 0.069), 0 5px 7px -1px rgba(0, 0, 0, 0.085), 0 9.7px 12.5px -1px rgba(0, 0, 0, 0.101), 0 19.7px 23.4px -1px rgba(0, 0, 0, 0.122), 0 54px 56px -1px rgba(0, 0, 0, 0.17)',
    },
};
